import * as React from "react";
import { forwardRef } from "react";
const SvgTagIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 25 25", style: {
  enableBackground: "new 0 0 25 25"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M25,11l0-11L14,0c0,0-0.1,0-0.1,0L0,13.9c0,0,0,0.1,0,0.1l11,11c0,0,0.1,0,0.1,0L25,11C25,11.1,25,11,25,11z M18.3,8.7 c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4S19.6,8.7,18.3,8.7z" }));
const ForwardRef = forwardRef(SvgTagIcon);
export { ForwardRef as ReactComponent };
